import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {MatTableModule} from '@angular/material/table';
import {NgbModal, ModalDismissReasons, NgbModalOptions, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {PowerModalComponent} from '../power-modal/power-modal.component'
import { MifielSignatureService } from 'src/app/services/mifiel-signature.service';
import { PowersAttorneyService } from '../../services/powers-attorney.service';
import { error } from 'console';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { NavigationEnd,ActivatedRoute, Router } from '@angular/router';
import { HttpEventType, HttpResponse , HttpErrorResponse} from '@angular/common/http';
import { PdlPersonModalComponent } from '../pdl-person-modal/pdl-person-modal.component';

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

export interface PowerElement {
  position: number;
  name: string;
  type: string;
  extension: string;
  attributes: string;
  status: string;
  notary: string;
  end_at: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H'},
  {position: 2, name: 'Helium', weight: 4.0026, symbol: 'He'},
  {position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li'},
  {position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be'},
  {position: 5, name: 'Boron', weight: 10.811, symbol: 'B'},
  {position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C'},
  {position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N'},
  {position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O'},
  {position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F'},
  {position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne'},
];

const POWER_DATA: PowerElement[] = [
  {position: 1 ,name: 'Angel Gaitan', type: 'Especial', extension: 'Individual', attributes: 'PD,DA', status: 'Vigente',notary: 'Eramos', end_at: '2024/12/12'},
  {position: 2, name: 'Tomas Gaitan', type: 'Especial', extension: 'Manocmunado', attributes: 'PD,T', status: 'Vencido',notary: 'Eramos', end_at: '2024/12/12'},
  {position: 3,name: 'Donald Trump', type: 'Especial', extension: 'Manocmunado', attributes: 'T', status: 'Vigente',notary: 'Eramos', end_at: '2024/12/12'}
];

export interface PowersByCompany {
  id: string;
  receiver: string;
  type: string;
}

const POWERS_DATA: PowersByCompany [] = [
  {id: '1', receiver: 'Gerardo de la Chapa García,', type: 'Individual', }
]



@Component({
  selector: 'app-power-of-attorney',
  templateUrl: './power-of-attorney.component.html',
  styleUrls: ['./power-of-attorney.component.css']
  // standalone: true,
  // imports: [MatTableModule],
})

export class PowerOfAttorneyComponent implements OnInit {
  @ViewChild('powerDocumentModal') powerDocumentModal: TemplateRef<any>;

  displayedColumns: string[] = [
    'position',
    'notary',
    'name',
    'type',
    'extension',
    'attributes',
    'tenancy_pdf',
    'original_pdf',
    'registered_pdf',
    'end_at',
    'status',
    'actions'
  ];
  // dataSource = ELEMENT_DATA;
  dataSource = POWER_DATA
  clickedRows = new Set<PeriodicElement>();
  powerEnable: boolean = false;
  message: string = '';
  thisMonthUsedCredits: number;
  canSignDocuments: boolean = false;
  /** Rows from API (each power + computed position). */
  powerResponse: any[] = [];

  documentModalRef: any;
  documentPreviewUrl: string | null = null;
  documentContentType = '';
  documentLoading = false;
  documentErrorMessage = '';
  currentPowerDocTitle = '';
  currentPowerDocFileName = '';

  
  constructor (private modalService: NgbModal,
    private uploadService: MifielSignatureService,
    private powersAttorneyService: PowersAttorneyService,
    private miFielSignatureService: MifielSignatureService, 
    private router: Router,
    private errorHandler: ErrorHandlerService,
  ){
    this.powerEnable = this.uploadService.getPowersEnabled();
  }

  ngOnInit(): void {
    // this.powerEnable = this.uploadService.getPowersEnabled();
    this.getPowersOfAttorneyList();


  }

  openAddPdlPerson() {
    const modalRef = this.modalService.open(PdlPersonModalComponent);
    // Context (sociedadRfc, shareholderUsuarioRfc) must be set when opening from a society/shareholder view.
    // When opened from here without context, save will show an error. Use Dashboard > Accionistas to add beneficiaries.
  }

  openAddPower(data?: any) {
    const modalRef = this.modalService.open(PowerModalComponent);
  
    // If there is previous data from a failed attempt, pass it to the modal
    if (data) {
      modalRef.componentInstance.powersOfAttorney = data;
    }
  
    modalRef.result.then(
      (result) => {
        console.log("Modal Return...");
        console.log(result);
        console.log(JSON.stringify(result))
        
        this.powersAttorneyService.save(result).subscribe(
          (response: any) => {
            if (response.success) {
              this.message = response.message || 'Upload successful';
              this.getPowersOfAttorneyList();
            } else {
              this.message = response.message || 'Error occurred';
              console.error("Error on openAddPower")
              console.error(response.data); // Optional: Log detailed error
            }
          },
          (err: any) => {
            this.message = 'Unexpected error occurred';
            console.error(err);
            this.openAddPower(result);
          }
        );
        

      },
      (reason) => {
        console.log('Modal dismissed with reason:', reason);
      }
    );
  }
  
  getPowersOfAttorneyList(){
    let userTaxId = localStorage.getItem('userTaxId');
    this.powersAttorneyService.list(userTaxId).subscribe(
      (response: any) => {
        if (response.success){
          const raw = response.data;
          this.powerResponse = Array.isArray(raw) ? raw.map((row: any, idx: number) => ({
            ...row,
            position: row?.position ?? idx + 1
          })) : [];
          console.log("power of attorney getPowersOfAttorneyList")
          console.log(this.powerResponse);
        }
        else {
          this.message = response.message || 'Error occurred';
          console.error("Error on getPowersOfAttorneyList")
          console.error(response.data); // Optional: Log detailed error
        } 
      },
      (err: any) => {
        this.message = 'Unexpected error occurred';
        console.error(err);
      }
    );

  }


  // loadCount(userTaxId: string): void {
  //   // Example of using an HTTP service that might fail

  //   this.uploadService.getCountByUserTaxId(userTaxId).subscribe({
  //     next: (data) => {
  //       console.log('Server Says...');
  //       // console.log(data);
  //       // console.log(typeof(data));
  //       console.log(data['thisMonthSignatures'])
  //       console.log(this.miFielSignatureService.getMaxMonthSignatures());
  //       if(this.miFielSignatureService.getMaxMonthSignatures() == null){
  //         localStorage.clear();
  //         this.router.navigate(['/']);
  //       }
  //       this.thisMonthUsedCredits = data['thisMonthSignatures'];
  //       if(  (this.miFielSignatureService.getMaxMonthSignatures() - this.thisMonthUsedCredits) > 0){
  //         this.canSignDocuments = true;
  //         console.log('can sign documents');
  //       }
  //       else{
  //         console.log('you can not sign, not credits left');
  //       }
  //     },
  //     error: (error) => {
  //       this.errorHandler.checkForError(error,'signature-fiel -> loadCount');
  //     }
  //   });
  // }

  // Method to calculate the status
  getStatus(element: any): string {
    const startDate = new Date(element.start_at).getTime();
    const endDate = new Date(element.end_at).getTime();
    return endDate > startDate ? 'Vigente' : 'Vencido';
  }

    // Clear the clicked rows
    clearClickedRows(): void {
      this.clickedRows.clear();
    }

  /** True when list payload indicates a stored file (name or MIME from API; binary is not serialized). */
  hasTenancyPowerDocument(element: any): boolean {
    const t = element?.tenancy;
    return this.hasStoredDocumentMeta(t?.idDocumentFileName, t?.idDocumentContentType);
  }

  hasOriginalPowerDocument(element: any): boolean {
    return this.hasStoredDocumentMeta(element?.originalPowerFileName, element?.originalPowerContentType);
  }

  hasRegisteredPowerDocument(element: any): boolean {
    return this.hasStoredDocumentMeta(element?.registeredPowerFileName, element?.registeredPowerContentType);
  }

  private hasStoredDocumentMeta(fileName?: string | null, contentType?: string | null): boolean {
    const fn = (fileName || '').trim();
    const ct = (contentType || '').trim();
    return fn.length > 0 || ct.length > 0;
  }

  openPowerDocumentModal(element: any, kind: 'tenancy' | 'original' | 'registered', event: Event): void {
    event.stopPropagation();
    const powerId = element?.id ?? element?._id;
    if (!powerId) {
      return;
    }
    if (kind === 'tenancy' && !this.hasTenancyPowerDocument(element)) {
      return;
    }
    if (kind === 'original' && !this.hasOriginalPowerDocument(element)) {
      return;
    }
    if (kind === 'registered' && !this.hasRegisteredPowerDocument(element)) {
      return;
    }

    if (this.documentPreviewUrl) {
      URL.revokeObjectURL(this.documentPreviewUrl);
      this.documentPreviewUrl = null;
    }
    this.documentContentType = '';
    this.documentErrorMessage = '';
    this.documentLoading = true;

    const titles: Record<typeof kind, string> = {
      tenancy: 'Documento de identificación (apoderado)',
      original: 'Poder (original)',
      registered: 'Poder registrado'
    };
    this.currentPowerDocTitle = titles[kind];
    this.currentPowerDocFileName = '';

    this.documentModalRef = this.modalService.open(this.powerDocumentModal, { size: 'xl' });

    const storedName =
      kind === 'tenancy'
        ? element?.tenancy?.idDocumentFileName
        : kind === 'original'
          ? element?.originalPowerFileName
          : element?.registeredPowerFileName;
    this.currentPowerDocFileName = storedName || '';

    this.powersAttorneyService.getPowerDocument(powerId, kind).subscribe({
      next: (res) => {
        const blob = res.body;
        let contentType = res.headers.get('Content-Type') || '';
        if (!contentType && storedName) {
          const ext = storedName.split('.').pop()?.toLowerCase();
          if (ext === 'pdf') contentType = 'application/pdf';
          else if (ext === 'jpg' || ext === 'jpeg') contentType = 'image/jpeg';
          else if (ext === 'png') contentType = 'image/png';
        }
        if (!contentType) contentType = 'application/pdf';
        if (blob && blob.size > 0) {
          this.documentPreviewUrl = URL.createObjectURL(blob);
          this.documentContentType = contentType;
        } else {
          this.documentErrorMessage = 'El documento está vacío o no está disponible.';
        }
      },
      error: () => {
        this.documentErrorMessage = 'No se pudo cargar el documento. Puede que no exista o no esté disponible.';
      },
      complete: () => {
        this.documentLoading = false;
      }
    });
  }

  closePowerDocumentModal(): void {
    if (this.documentPreviewUrl) {
      URL.revokeObjectURL(this.documentPreviewUrl);
      this.documentPreviewUrl = null;
    }
    this.documentModalRef?.close();
  }

  isPdfContent(): boolean {
    return !!(this.documentContentType && this.documentContentType.toLowerCase().includes('application/pdf'));
  }

  isImageContent(): boolean {
    if (!this.documentContentType) return false;
    const t = this.documentContentType.toLowerCase().split(';')[0].trim();
    return t.startsWith('image/');
  }

  getImageTypeLabel(): string {
    if (!this.documentContentType) return 'Imagen';
    const t = this.documentContentType.toLowerCase().split(';')[0].trim();
    if (t.includes('jpeg') || t.includes('jpg')) return 'JPEG';
    if (t.includes('png')) return 'PNG';
    return 'Imagen';
  }

  getPowerDownloadFileName(): string {
    if (this.currentPowerDocFileName) return this.currentPowerDocFileName;
    const ext = this.isPdfContent() ? 'pdf' : (this.isImageContent() ? (this.documentContentType?.includes('png') ? 'png' : 'jpg') : 'bin');
    return `documento-poder.${ext}`;
  }

  deletePower(element: any, event: Event): void {
    event.stopPropagation();
    const id = element.id ?? element._id;
    if (!id) {
      this.message = 'No se puede eliminar: elemento sin identificador.';
      return;
    }
    if (!confirm('¿Eliminar este poder?')) {
      return;
    }
    this.powersAttorneyService.deleteById(id).subscribe({
      next: () => {
        this.message = 'Poder eliminado correctamente.';
        this.getPowersOfAttorneyList();
        this.clickedRows.delete(element);
      },
      error: (err) => {
        this.message = err?.error?.message ?? err?.message ?? 'Error al eliminar el poder.';
        console.error(err);
      }
    });
  }

}
